import script from "./form-group.vue?vue&type=script&setup=true&lang=js"
export * from "./form-group.vue?vue&type=script&setup=true&lang=js"

import "./form-group.vue?vue&type=style&index=0&id=50fa28b6&lang=scss"

const __exports__ = script;

export default __exports__